// extracted by mini-css-extract-plugin
export default {"empty":"WidgetEmpty_empty__yhisR","icon":"WidgetEmpty_icon__36xWD","title":"WidgetEmpty_title__vjbq2","hint":"WidgetEmpty_hint__eQ7hN"};